import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { JobcanIdLogo, JobcanUser, Pulldown } from './icons';
import Cookies from 'js-cookie';
import onClickOutside from 'react-onclickoutside';
import styles from './JobcanHeader.scss';

const DOMAINS = (env => {
  switch (env) {
    case 'development2':
      return {
        jbcId: 'https://dev.id.jobcan.jp',
        atd: 'https://dev.jobcan.jp',
        wf: 'https://jbcwf-stage-mz352g.appspot.com',
        ats: 'https://z9d8ek6c.dev2.ats.jobcan.jp',
        lms: 'https://lms-development2.donuts-roumu-xxx.de',
        tm: 'https://lms-development2.donuts-roumu-xxx.de',
        payroll: 'https://dev2-donuts-payroll-xxx.de',
        acc: 'https://pre-portal.bizsoft.jp',
        inv: 'https://pre-portal.bizsoft.jp',
        evm: 'https://pre-portal.bizsoft.jp',
      };
    case 'staging':
      return {
        jbcId: 'https://staging.id.jobcan.jp',
        atd: 'https://stage.jobcan.jp',
        wf: 'https://jbcwf-stage-mz352g.appspot.com',
        ats: 'https://z9d8ek6c.dev2.ats.jobcan.jp',
        lms: 'https://lms-staging.donuts-roumu-xxx.de',
        tm: 'https://lms-staging.donuts-roumu-xxx.de',
        payroll: 'https://stg.dev-donuts-payroll-xxx.de',
        acc: 'https://dev.ac.jobcan.jp',
        inv: 'https://dev.ac.jobcan.jp',
        evm: 'https://dev.evm.jobcan.jp',
      };
    case 'local':
      return {
        jbcId: process.env.JBC_ID_DOMAIN || 'https://id.jobcan.jp',
        atd: process.env.ATD_DOMAIN || 'https://ssl.jobcan.jp',
        wf: process.env.WF_DOMAIN || 'https://ssl.wf.jobcan.jp',
        ats: process.env.ATS_DOMAIN || 'https://ats.jobcan.jp',
        lms: process.env.LMS_DOMAIN || 'https://lms.jobcan.jp',
        tm: process.env.TM_DOMAIN || 'https://lms.jobcan.jp',
        payroll: process.env.PAYROLL_DOMAIN || 'https://payroll.jobcan.jp',
        acc: process.env.ACC_DOMAIN || 'https://ac.jobcan.jp',
        inv: process.env.INV_DOMAIN || 'https://ac.jobcan.jp',
        evm: process.env.EVM_DOMAIN || 'https://evm.jobcan.jp',
      };
    default:
      return {
        jbcId: 'https://id.jobcan.jp',
        atd: 'https://ssl.jobcan.jp',
        wf: 'https://ssl.wf.jobcan.jp',
        ats: 'https://ats.jobcan.jp',
        lms: 'https://lms.jobcan.jp',
        tm: 'https://lms.jobcan.jp',
        payroll: 'https://payroll.jobcan.jp',
        acc: 'https://ac.jobcan.jp',
        inv: 'https://ac.jobcan.jp',
        evm: 'https://evm.jobcan.jp',
      };
  }
})(process.env.SERVER_ENV);

class _JbcMenu extends Component {
  handleClickOutside = () => {
    document.getElementById('jbcid-user-menu').classList.remove('open');
  };

  handleClick = () => {
    document.getElementById('jbcid-user-menu').classList.toggle('open');
  };

  render() {
    const { user, logout } = this.props;
    const password = `${DOMAINS.jbcId}/account/password`;

    return (
      <ul className={styles.navlists}>
        <li className={styles.usermenu} id="jbcid-user-menu">
          <a
            href="#"
            className={`${styles.usermenu_toggle} ignore-react-onclickoutside`}
            id="jbcid-dropdown-button"
            onClick={this.handleClick}
          >
            <JobcanUser className={styles.account_image} size={16} />
            <span>{user}</span>
            <span>
              <Pulldown size={10} />
            </span>
          </a>
          <ul className={styles.usermenu_items}>
            <li>
              <a rel="nofollow noreferrer" href={password} target="_blank">
                パスワード変更
              </a>
            </li>
            <li>
              <span onClick={logout}>ログアウト</span>
            </li>
          </ul>
        </li>
      </ul>
    );
  }
}

const JobcanHeader = ({ user, logout, label, jobcanLogoUrl }) => {
  const naviItems = [
    {
      link: `${DOMAINS.atd}/jbcoauth/login`,
      label: '勤怠',
      display: Cookies.get('using_jbc_atd') === 'true',
    },
    {
      link: `${DOMAINS.wf}/jbc-oauth/login`,
      label: '経費/WF',
      display: Cookies.get('using_jbc_wf') === 'true',
    },
    {
      link: `${DOMAINS.ats}/jbc-oauth/login`,
      label: '採用',
      display: Cookies.get('using_jbc_ats') === 'true',
    },
    {
      link: `${DOMAINS.lms}/api/jbc-oauth/login`,
      label: '労務',
      display: Cookies.get('using_jbc_lms') === 'true',
    },
    {
      link: `${DOMAINS.tm}/api/jbc-oauth/login?d=tm`,
      label: '人材',
      display: Cookies.get('using_jbc_tm') === 'true',
    },
    {
      link: `${DOMAINS.payroll}/oauth/jbc/login`,
      label: '給与',
      display: Cookies.get('using_jbc_payroll') === 'true',
    },
    {
      link: `${DOMAINS.acc}/portal/u/jbcoauth/login?moduleid=X000`,
      label: '会計',
      display: Cookies.get('using_jbc_acc') === 'true',
    },
    {
      link: `${DOMAINS.evm}/portal/u/jbcoauth/login?moduleid=Y000`,
      label: '証憑',
      display: Cookies.get('using_jbc_evm') === 'true',
    },
    {
      link: `${DOMAINS.inv}/portal/u/jbcoauth/login?moduleid=V000`,
      label: '見積/請求書',
      display: Cookies.get('using_jbc_inv') === 'true',
    },
  ];

  return (
    <header className={styles.header}>
      <nav className={styles.navbar} role="navigation">
        <div className={styles.logowrap}>
          <a className={styles.logo} href={`${jobcanLogoUrl || DOMAINS.jbcId}`} target="_blank" rel="noreferrer">
            <JobcanIdLogo />
          </a>
        </div>
        <div className={styles.navwrap}>
          <ul className={styles.navlists}>
            {naviItems.map(
              naviItem =>
                naviItem.display && (
                  <li key={naviItem.label}>
                    <a
                      className={naviItem.label === label ? styles.applink_active : styles.applink}
                      href={naviItem.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {naviItem.label}
                    </a>
                  </li>
                ),
            )}
          </ul>
        </div>
        <div className={styles.logout} id="xs-logout">
          <ul className={styles.navlists}>
            <li>
              <span className={styles.applink} onClick={logout}>
                ログアウト
              </span>
            </li>
          </ul>
        </div>
        <div className={styles.user}>
          <JbcMenu user={user} logout={logout} />
        </div>
      </nav>
    </header>
  );
};

const JbcMenu = onClickOutside(_JbcMenu);

JobcanHeader.propTypes = {
  user: PropTypes.string.isRequired,
  logout: PropTypes.func.isRequired,
};

export default JobcanHeader;
